<template>

    <div>

        <Head :title="$t('templates.editTitle')" />

        <page-title :title="$t('templates.editTitle')"></page-title>

        <manage-topics
            :type = "'template'"
            :suppliers="suppliers"
            :options="options"
            :template="template"
            :form="topicsForm"
            :saveLink="route('advisors.templates.updateTopics', this.template.uuid)"
            :goBackLink="route('advisors.templates.index', this.template.uuid)"
        ></manage-topics>

    </div>
</template>


<script>
import { defineComponent } from "vue";
import MainLayout from "@/Layouts/MainLayout";
import { useForm } from "@inertiajs/inertia-vue3";
import FormCard from "@/Shared/Components/FormCard";
import PageTitle from "@/Shared/Components/PageTitle";
import ManageTopics from "@/Pages/Templates/Components/ManageTopics";
import { Head } from "@inertiajs/inertia-vue3";

export default defineComponent({
    props: ["template", "topics", "suppliers", "options"],
    layout: MainLayout,
    components: {
        Head,
        ManageTopics,
        PageTitle,
        FormCard
    },
    methods: {},
    setup(props) {
        const topicsForm = useForm({
            topics: props.topics.map(d => d)
        });

        return { topicsForm };
    }
});
</script>

<style scoped></style>
